export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "Show less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show less"])},
      "Show more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show more"])}
    }
  })
}
